import { render, staticRenderFns } from "./EnrichmentModal.vue?vue&type=template&id=4be69009&"
import script from "./EnrichmentModal.vue?vue&type=script&lang=js&"
export * from "./EnrichmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports